import {
  Component,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'ag-accordion-header',
  templateUrl: './accordion-header.component.html',
  styleUrls: ['./accordion-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class AccordionHeaderComponent {
  isActive = false;

  onToggle: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  toggle() {
    this.isActive = !this.isActive;
    this.onToggle.emit(this.isActive);
  }

  setIsActive(isActive) {
    this.isActive = isActive;
    this.onToggle.emit(this.isActive);
  }
}
